import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { CatCategoryPromoterComponent } from 'src/oldApp/catalogs/components/cat-category-promoter/cat-category-promoter.component';
import { ScPromoterCategoryComponent } from 'src/oldApp/catalogs/components/sc-promoter-category/sc-promoter-category.component';
import { HoldReleaseCommissionComponent } from 'src/app/pages/hold-release-commission/hold-release-commission.component';
import { SchemeConfiguratorComponent } from 'src/oldApp/pages/components/scheme-configurator/scheme-configurator.component';
import { NotFoundComponent } from 'src/oldApp/shared/not-found/not-found.component';
import { ComisionesSimuladorComponent } from '../pages/comisiones-simulador/comisiones-simulador.component';
import { CommissionCatPromotionsComponent } from '../pages/configurador-comisiones/commission-cat-promotions/commission-cat-promotions.component';
import { CommissionConfigPromotionsComponent } from '../pages/configurador-comisiones/commission-config-promotions/commission-config-promotions.component';
import { HomeComponent } from '../pages/home/home.component';
import { LoginComponent } from '../pages/login/login.component';
import { ComisionesCargaComponent } from '../pages/nomina/comisiones-manuales/comisiones-carga/comisiones-carga.component';
import { ComisionesDocumentosComponent } from '../pages/nomina/comisiones-manuales/comisiones-documentos/comisiones-documentos.component';
import { ComisionesEnvioComponent } from '../pages/nomina/comisiones-manuales/comisiones-envio/comisiones-envio.component';
import { ComisionesRetencionesComponent } from '../pages/nomina/comisiones-manuales/comisiones-retenciones/comisiones-retenciones.component';
import { NominaComponent } from '../pages/nomina/reportes/nomina.component';
import { PagosDistribuidorComponent } from '../pages/nomina/pagos-distribuidor/pagos-distribuidor.component';
import { PagesComponent } from '../pages/pages.component';
import { environment } from 'src/environments/environment';
import { ViewHoldReleaseCommissionComponent } from '../pages/view-hold-release-commission/view-hold-release-commission.component';
import { ConfiguradorComponent } from 'src/app/pages/comisiones/configurador/configurador.component';
import { ConfiguradorV2Component } from 'src/app/pages/comisiones/configurador-v2/configurador-v2.component';
import { ModalConfigPromotionComponent } from '../shared/modal-config-promotion/modal-config-promotion.component';
import { ModalConfigPromotionV2Component } from '../shared/modal-config-promotion-v2/modal-config-promotion-v2.component';
import { ConsultaConfigComponent } from '../pages/comisiones/consulta/consulta-config.component';
import { ConsultaConfigV2Component } from '../pages/comisiones/consulta-v2/consulta-config-v2.component';
import { CumplimientoMetasComponent } from '../pages/comisiones/cumplimiento-metas/cumplimento-metas.component';
import { CatBusinessLineComponent } from '../pages/catalogos-comisiones/cat-business-line/cat-business-line.component';
import { CatProductComponent } from '../pages/catalogos-comisiones/cat-product/cat-product.component';
import { CatSubProductComponent } from '../pages/catalogos-comisiones/cat-sub-product/cat-sub-product.component';
import { CatTermComponent } from '../pages/catalogos-comisiones/cat-term/cat-term.component';
import { CatEmployeeJobCatalogoComponent } from '../pages/catalogos-comisiones/cat-employee-job/cat-employee-job.component';
import { CatSaleTypeComponent } from '../pages/catalogos-comisiones/cat-sale-type/cat-sale-type.component';
import { CatAgreementComponent } from '../pages/catalogos-comisiones/cat-agreement/cat-agreement.component';
import { CatEmployeesComponent } from '../pages/catalogos-comisiones/cat-employees/cat-employees.component';
import { CatPersonCreditsComponent } from '../pages/catalogos-comisiones/cat-person-credits/cat-person-credits.component';
import { CatCategoryPromoterCatalogoComponent } from '../pages/catalogos-comisiones/cat-category-promoter/cat-category-promoter.component';
import { CommissionPromoterCategoryComponent } from '../pages/catalogos-comisiones/commission-promoter-category/commission-promoter-category.component';
import { PromotorCategoryAssignmentComponent } from '../pages/catalogos-comisiones/promotor-category-assignment/promotor-category-assignment.component';
import { CatComponentsComponent } from '../pages/administracion/cat-components/cat-components.component';
import { ComponentRolesComponent } from '../pages/administracion/component-roles/component-roles.component';

// Interfaz para las rutas del servicio
interface ServiceRoute {
  roles: string[] | null;
  path: string;
  component: string;
  children: ServiceRoute[] | null;
}

@Injectable({
  providedIn: 'root'
})
export class RoutesService {

  // Mapa de componentes (nombre string -> componente real)
  // IMPORTANTE: Todos estos componentes deben estar declarados en el AppModule
  private componentMap: { [key: string]: any } = {
    'LoginComponent': LoginComponent,
    'PagesComponent': PagesComponent,
    'HomeComponent': HomeComponent,
    'NominaComponent': NominaComponent,
    'ComisionesCargaComponent': ComisionesCargaComponent,
    'ComisionesEnvioComponent': ComisionesEnvioComponent,
    'ComisionesDocumentosComponent': ComisionesDocumentosComponent,
    'ComisionesRetencionesComponent': ComisionesRetencionesComponent,
    'ComisionesSimuladorComponent': ComisionesSimuladorComponent,
    'SchemeConfiguratorComponent': SchemeConfiguratorComponent,
    'HoldReleaseCommissionComponent': HoldReleaseCommissionComponent,
    'CommissionCatPromotionsComponent': CommissionCatPromotionsComponent,
    'CommissionConfigPromotionsComponent': CommissionConfigPromotionsComponent,
    'CatCategoryPromoterComponent': CatCategoryPromoterComponent,
    'ScPromoterCategoryComponent': ScPromoterCategoryComponent,
    'ViewHoldReleaseCommissionComponent': ViewHoldReleaseCommissionComponent,
    'PagosDistribuidorComponent': PagosDistribuidorComponent,
    'ConfiguradorComponent': ConfiguradorComponent,
    'ConfiguradorV2Component': ConfiguradorV2Component,
    'ConsultaConfigComponent': ConsultaConfigComponent,
    'ConsultaConfigV2Component': ConsultaConfigV2Component,
    'CumplimientoMetasComponent': CumplimientoMetasComponent,
    'NotFoundComponent': NotFoundComponent,
    'CatBusinessLineComponent': CatBusinessLineComponent,
    'CatProductComponent': CatProductComponent,
    'CatSubProductComponent': CatSubProductComponent,
    'CatTermComponent': CatTermComponent,
    'CatEmployeeJobCatalogoComponent': CatEmployeeJobCatalogoComponent,
    'CatSaleTypeComponent': CatSaleTypeComponent,
    'CatAgreementComponent': CatAgreementComponent,
    'CatEmployeesComponent': CatEmployeesComponent,
    'CatPersonCreditsComponent': CatPersonCreditsComponent,
    'CatCategoryPromoterCatalogoComponent': CatCategoryPromoterCatalogoComponent,
    'CommissionPromoterCategoryComponent': CommissionPromoterCategoryComponent,
    'PromotorCategoryAssignmentComponent': PromotorCategoryAssignmentComponent,
    'CatComponentsComponent': CatComponentsComponent,
    'ComponentRolesComponent': ComponentRolesComponent,
  };

  private apiUrl: string; // URL BASE del servicio de rutas

  // Método para verificar que todos los componentes estén mapeados correctamente
  private validateComponentMap(): void {
    Object.entries(this.componentMap).forEach(([key, component]) => {
      if (!component) {
        console.error(`Componente no encontrado: ${key}`);
      }
    });
  }

  /**
   * Obtiene el componente de Login (útil para rutas de fallback)
   */
  getLoginComponent(): any {
    return LoginComponent;
  }

  /**
   * Obtiene el componente de Login (útil para rutas de fallback)
   */
  getPagesComponent(): any {
    return PagesComponent;
  }



  /**
   * Obtiene el componente NotFound (útil para rutas de fallback)
   */
  getNotFoundComponent(): any {
    return NotFoundComponent;
  }

  constructor(private http: HttpClient) {
    // Validar componentes al inicializar el servicio
    this.apiUrl = environment.services_url;
    this.validateComponentMap();
  }

  /**
   * Obtiene las rutas desde el servicio backend
   */
  getRoutesFromService(): Observable<ServiceRoute[]> {
    return this.http.get<any>(this.apiUrl + '/CatComponent/ListRoutes').pipe(
      map(response => response.data)
    );
  }

  /**
   * Convierte las rutas del servicio a Routes de Angular
   */
  getAngularRoutes(): Observable<Routes> {
    return this.getRoutesFromService().pipe(
      map(serviceRoutes => this.buildRoutesFromService(serviceRoutes))
    );
  }

  /**
   * Construye el arreglo de Routes de Angular desde las rutas del servicio
   */
  private buildRoutesFromService(serviceRoutes: ServiceRoute[]): Routes {
    // Convertir rutas dinámicas del servicio
    const dynamicChildren: Routes = [];
    serviceRoutes.forEach(route => {
      const angularRoute = this.convertToAngularRoute(route);
      if (angularRoute) {
        dynamicChildren.push(angularRoute);
      }
    });

    const routes: Routes = [
      // Rutas estáticas (login y redirect)
      { path: "", redirectTo: "login", pathMatch: "full" },
      { path: "login", component: LoginComponent },
      {
        path: "home",
        component: PagesComponent,
        canActivate: [AuthGuard],
        children: [{ path: "comisiones", component: HomeComponent }]
      },
      // Todas las rutas dinámicas como children de PagesComponent (con sidebar)
      {
        path: "",
        component: PagesComponent,
        canActivate: [AuthGuard],
        children: [
          ...dynamicChildren  // Agregar todas las rutas dinámicas aquí
        ]
      },
    ];

    // Agregar rutas adicionales que no vienen del servicio
    this.addCustomRoutes(routes);

    return routes;
  }

  /**
   * Convierte una ruta del servicio a formato Angular Route
   */
  private convertToAngularRoute(serviceRoute: ServiceRoute): any {
    // Si es una ruta especial (404, **), manejarla diferente
    if (serviceRoute.path === '404' || serviceRoute.path === '**') {
      return {
        path: serviceRoute.path,
        component: this.componentMap[serviceRoute.component] || NotFoundComponent,
      };
    }

    // PagesComponent ya funciona como shell principal.
    // Si vuelve a llegar desde el backend, se usa solo como agrupador.
    if (serviceRoute.component === 'PagesComponent' &&
      serviceRoute.children &&
      serviceRoute.children.length > 0) {
      const route: any = {
        path: serviceRoute.path,
        canActivate: [AuthGuard],
      };

      if (serviceRoute.roles && serviceRoute.roles.length > 0) {
        route.data = { roles: serviceRoute.roles };
      }

      if (serviceRoute.children && serviceRoute.children.length > 0) {
        route.children = serviceRoute.children
          .map(child => this.convertChildRoute(child))
          .filter(child => !!child);
      }

      return route;
    }

    const route: any = {
      path: serviceRoute.path,
      component: this.componentMap[serviceRoute.component],
      canActivate: [AuthGuard],
    };

    // Agregar data con roles si existen
    if (serviceRoute.roles && serviceRoute.roles.length > 0) {
      route.data = { roles: serviceRoute.roles };
    }

    // Procesar children si existen
    if (serviceRoute.children && serviceRoute.children.length > 0) {
      route.children = serviceRoute.children.map(child =>
        this.convertChildRoute(child)
      );
    }

    return route;
  }

  /**
   * Convierte una ruta child del servicio
   */
  private convertChildRoute(childRoute: ServiceRoute): any {
    if (childRoute.component === 'PagesComponent' &&
      childRoute.children &&
      childRoute.children.length > 0) {
      const route: any = {
        path: childRoute.path,
      };

      if (childRoute.roles && childRoute.roles.length > 0) {
        route.canActivate = [AuthGuard];
        route.data = { roles: childRoute.roles };
      }

      if (childRoute.children && childRoute.children.length > 0) {
        route.children = childRoute.children
          .map(grandChild => this.convertChildRoute(grandChild))
          .filter(grandChild => !!grandChild);
      }

      return route;
    }

    const route: any = {
      path: childRoute.path,
      component: this.componentMap[childRoute.component] || NotFoundComponent,
    };

    // Agregar canActivate y roles a children si es necesario
    if (childRoute.roles && childRoute.roles.length > 0) {
      route.canActivate = [AuthGuard];
      route.data = { roles: childRoute.roles };
    }

    // Procesar children anidados si existen
    if (childRoute.children && childRoute.children.length > 0) {
      route.children = childRoute.children.map(grandChild =>
        this.convertChildRoute(grandChild)
      );
    }

    return route;
  }

  /**
   * Agrega rutas personalizadas que no vienen del servicio
   * Por ejemplo: rutas con parámetros, rutas de catálogos, etc.
   */
  private addCustomRoutes(routes: Routes): void {
    const shellRoute = routes.find(r => r.path === '' && r.component === PagesComponent);
    const shellChildren = (shellRoute && shellRoute.children ? shellRoute.children : []) as Routes;

    // Buscar la ruta de nómina para agregar la ruta con parámetro
    const nominaRouteIndex = shellChildren.findIndex(r => r.path === 'nomina');

    if (nominaRouteIndex !== -1 && shellChildren[nominaRouteIndex].children) {
      const nominaChildren = shellChildren[nominaRouteIndex].children as Routes;

      // Agregar ruta con parámetro si no existe
      const hasEnvioRoute = nominaChildren.some(child =>
        child.path === 'envioComisiones/:id'
      );

      if (!hasEnvioRoute) {
        nominaChildren.push({
          path: 'envioComisiones/:id',
          component: ComisionesEnvioComponent,
          canActivate: [AuthGuard],
        });
      }
    }
    console.log('Rutas después de agregar personalizadas:', routes);

    // Buscar la ruta de promociones para agregar la ruta con parámetro
    const configuracionesIdx = shellChildren.findIndex(r => r.path === 'promociones');

    if (configuracionesIdx !== -1 && shellChildren[configuracionesIdx].children) {
      const promocionesChildren = shellChildren[configuracionesIdx].children as Routes;

      // Agregar ruta con parámetro si no existe
      const hasEnvioRoute = promocionesChildren.some(child =>
        child.path === 'configurador-promociones'
      );
      console.log('Rutas de promociones antes de agregar personalizadas:', promocionesChildren);
      const hasEnvioRouteHistorico = promocionesChildren.some(child =>
        child.path === 'consulta-historico-configuracion');

      if (!hasEnvioRoute) {
        promocionesChildren.push({
          path: 'configurador-promociones',
          component: ModalConfigPromotionComponent,
          canActivate: [AuthGuard],
        });
      }

      if (!hasEnvioRouteHistorico) {
        promocionesChildren.push({
          path: 'consulta-historico-configuracion',
          component: ConsultaConfigComponent,
          canActivate: [AuthGuard],
        });
      }

      // Agregar rutas V2
      const hasConfiguradorV2Route = promocionesChildren.some(child =>
        child.path === 'configurador-v2'
      );
      const hasConfiguradorPromocioneV2Route = promocionesChildren.some(child =>
        child.path === 'configurador-promociones-v2'
      );
      const hasHistoricoConfiguracionV2Route = promocionesChildren.some(child =>
        child.path === 'consulta-historico-configuracion-v2'
      );

      if (!hasConfiguradorV2Route) {
        promocionesChildren.push({
          path: 'configurador-v2',
          component: ConfiguradorV2Component,
          canActivate: [AuthGuard],
        });
      }

      if (!hasConfiguradorPromocioneV2Route) {
        promocionesChildren.push({
          path: 'configurador-promociones-v2',
          component: ModalConfigPromotionV2Component,
          canActivate: [AuthGuard],
        });
      }

      if (!hasHistoricoConfiguracionV2Route) {
        promocionesChildren.push({
          path: 'consulta-historico-configuracion-v2',
          component: ConsultaConfigV2Component,
          canActivate: [AuthGuard],
        });
      }
    }

    // Buscar o crear la ruta de catálogos si no existe
    const catalogosRouteIndex = shellChildren.findIndex(r => r.path === 'catalogos');

    if (catalogosRouteIndex === -1) {
      // Si no existe la ruta de catálogos, agregarla
      shellChildren.push({
        path: 'catalogos',
        children: [
          {
            path: 'categoria-promotor',
            component: CatCategoryPromoterComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'es-categoria-promotor',
            component: ScPromoterCategoryComponent,
            canActivate: [AuthGuard],
          },
        ],
      });
    }
  }

  /**
   * Método auxiliar para obtener las rutas de forma síncrona 
   * (útil para testing o casos especiales)
   */
  buildRoutesFromServiceData(serviceRoutes: ServiceRoute[]): Routes {
    return this.buildRoutesFromService(serviceRoutes);
  }

  /**
   * Carga las rutas y actualiza el router
   * Este método debe ser llamado desde el AppComponent
   */
  loadAndSetRoutes(router: any): Promise<void> {
    return this.getAngularRoutes()
      .toPromise()
      .then(routes => {
        router.resetConfig(routes);
        console.log('=== RUTAS CARGADAS DINÁMICAMENTE ===');
        // console.log(JSON.stringify(routes, null, 2));
      })
      .catch(error => {
        console.error('Error al cargar rutas:', error);
        // En caso de error, cargar rutas mínimas de fallback
        router.resetConfig([
          { path: "", redirectTo: "login", pathMatch: "full" },
          { path: "login", component: LoginComponent },
          { path: "**", component: NotFoundComponent }
        ]);
      });
  }
}
